import { EarningsTableStatus } from '../types';

/**
 * Calculates deposit status based on dates
 */
export const calculateDepositStatus = (
  withdrawalDate: string,
  stakingEndDate: string
): EarningsTableStatus => {
  const now = Date.now() / 1000;
  const withdrawal = +withdrawalDate;
  const endDate = +stakingEndDate;

  // Withdrawn early
  if (withdrawal !== 0 && withdrawal < endDate) {
    return EarningsTableStatus.WITHDRAWN;
  }

  // Claimed after period ended
  if (withdrawal !== 0 && withdrawal >= endDate) {
    return EarningsTableStatus.CLAIMED;
  }

  // Flexible/Indefinite (no end date)
  if (withdrawal === 0 && endDate === 0) {
    return EarningsTableStatus.FLEXIBLE;
  }

  // Still locked
  if (withdrawal === 0 && now < endDate) {
    return EarningsTableStatus.DAYS_LEFT;
  }

  // Ready to claim
  if (withdrawal === 0 && now >= endDate) {
    return EarningsTableStatus.FINISHED;
  }

  return EarningsTableStatus.DAYS_LEFT;
};

/**
 * Calculates days left until staking end
 */
export const calculateDaysLeft = (stakingEndDate: string): number | null => {
  const endDate = +stakingEndDate;
  if (endDate === 0) return null; // Flexible

  const now = Date.now() / 1000;
  if (now >= endDate) return 0;

  return Math.ceil((endDate - now) / 86400);
};

/**
 * Determines if deposit can be claimed
 */
export const canClaimDeposit = (status: EarningsTableStatus, rewards: string): boolean => {
  const claimableStatuses = [EarningsTableStatus.FINISHED, EarningsTableStatus.FLEXIBLE];
  return claimableStatuses.includes(status) && +rewards > 0;
};

/**
 * Determines if deposit can be withdrawn
 */
export const canWithdrawDeposit = (status: EarningsTableStatus, isWhitelisted: boolean): boolean => {
  if (isWhitelisted) {
    return status === EarningsTableStatus.FLEXIBLE;
  }
  const withdrawableStatuses = [EarningsTableStatus.DAYS_LEFT, EarningsTableStatus.FLEXIBLE];
  return withdrawableStatuses.includes(status);
};
